var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCollege2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.33 36.658c.431.172.862.172 1.293 0l23.574-8.774V48.13c.604-.129 1.207-.257 1.854-.257.646 0 1.25.085 1.853.257V26.47l2.629-.942c1.594-.599 1.594-2.867 0-3.467L40.58 10.933c-.431-.17-.905-.17-1.293 0L9.334 22.063c-1.594.599-1.594 2.867 0 3.466L39.33 36.66zM66.22 52.277c-3.16 0-5.55 4.087-5.55 9.493v3.823c0 1.055.81 1.89 1.835 1.89h7.387c1.025 0 1.836-.835 1.836-1.89V61.77c.043-5.406-2.348-9.493-5.508-9.493z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.449 34.306-17.525 6.28a5.904 5.904 0 0 1-3.967 0l-17.525-6.28c-1.57 5.49-1.177 9.108-1.22 10.231 0 1.29 1.35 2.163 2.571 1.664.044 0 4.447-1.664 8.72-1.664 3.966 0 8.195 3.161 8.238 3.203.654.499 1.657.54 2.355 0 1.177-.874 4.926-3.203 8.239-3.203 4.272 0 8.675 1.664 8.719 1.664 1.22.457 2.572-.416 2.572-1.664 0-1.081.392-4.741-1.177-10.231z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCollege2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-college-2.b55e1e3d061277b26fa0434e5cd9b135.svg";